// extracted by mini-css-extract-plugin
module.exports = {"root":"sortedByContainer_root__2QHw8","sortText":"sortedByContainer_sortText__1DQyG"};